<template>
  <div id="consultarManifestacaoWrapper">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres :titulo="titulo" breakpoint="md" :voltar="true" />
      </template>
      <b-tabs card v-if="manifestacao">
        <b-tab title="Dados Gerais">
          <DadosGeraisOuvidoria
            :manifestacao="manifestacao"
            :nomeManifestante="nomeManifestante"
          />
        </b-tab>
        <b-tab title="Prorrogações" v-if="manifestacao.IdManifestacao">
          <ProrrogacoesOuvidoria
            :idManifestacao="manifestacao.IdManifestacao"
          />
        </b-tab>
        <b-tab title="Andamentos" v-if="manifestacao.IdManifestacao">
          <AndamentosOuvidoria
            :idManifestacao="manifestacao.IdManifestacao"
            :numManifestacao="this.manifestacao.Numero"
            :anoManifestacao="this.manifestacao.Ano"
          />
        </b-tab>
        <b-tab title="Arquivos" v-if="manifestacao.IdManifestacao">
          <ArquivosOuvidoria :idManifestacao="manifestacao.IdManifestacao" />
        </b-tab>
      </b-tabs>
      <div v-else class="text-center text-dark">
        <b-spinner class="align-middle" />
        <strong class="loading-text">Carregando...</strong>
      </div>
    </b-card>
  </div>
</template>

<script lang="ts">
import ouvidoriaService from "@/services/administracao/ouvidoriaService";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue, Watch } from "vue-property-decorator";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { Manifestacao } from "@/types/administracao/ouvidoria/manifestacao";
import usuarioService from "@/services/administracao/usuarioService";
import { defaultCPFFormatter } from "@/types/table-field";
import ArquivosOuvidoria from "@/components/administracao/ouvidoria/ArquivosOuvidoria.vue";
import AndamentosOuvidoria from "@/components/administracao/ouvidoria/AndamentosOuvidoria.vue";
import DadosGeraisOuvidoria from "@/components/administracao/ouvidoria/DadosGeraisOuvidoria.vue";
import ProrrogacoesOuvidoria from "@/components/administracao/ouvidoria/ProrrogacoesOuvidoria.vue";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";

const ROTA_VISUALIZAR_MANIFESTACAO_MURAL = "/mural-avisos/manifestacoes/";
const ROTA_VISUALIZAR_MANIFESTACAO_OUVIDORIA =
  "/administracao/ouvidoria/visualiza-manifestacao/";

const CompProps = Vue.extend({
  name: "VisualizaManifestacao",
  components: {
    HeaderSagres,
    DadosGeraisOuvidoria,
    ProrrogacoesOuvidoria,
    AndamentosOuvidoria,
    ArquivosOuvidoria,
  },
  props: {
    idManifestacao: {
      type: String,
      required: true,
    },
  },
});

@Component
export default class VisualizaManifestacao extends mixins(UtilsTS, CompProps) {
  isBusy = true;
  titulo = "";
  nomeManifestante: any = "";

  manifestacao: Manifestacao | null = null;

  async nameByCpf(cpf: string): Promise<any> {
    try {
      const response = await usuarioService.findByCpfNome(cpf);
      return this.capitalize(response[0].Nome);
    } catch (error: unknown) {
      this.tratarError(error);
    }
  }

  async carregaManifestacao(): Promise<void> {
    try {
      this.isBusy = true;
      const response = await ouvidoriaService.getManifestacaoById(
        Number(this.idManifestacao)
      );
      this.manifestacao = response;
      this.titulo = `Manifestação ${this.manifestacao.Numero}/${this.manifestacao.Ano}`;
      this.nomeManifestante = await this.nameByCpf(
        this.manifestacao.IdUsuarioManifestante
      );
      this.manifestacao.IdUsuarioManifestante = defaultCPFFormatter(
        this.manifestacao.IdUsuarioManifestante
      );
      if (!this.manifestacao.CodProtocoloEtce)
        this.manifestacao.CodProtocoloEtce = "Não protocolado";
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.isBusy = false;
    }
  }

  @Watch("idManifestacao")
  async onIdManifestacaoChange(
    newIdManifestacao: string,
    oldIdManifestacao: string
  ): Promise<void> {
    if (newIdManifestacao === oldIdManifestacao) return;
    await this.carregaManifestacao();
  }

  isRotaVisualizarManifestacaoMural(path: string): boolean {
    return path.startsWith(ROTA_VISUALIZAR_MANIFESTACAO_MURAL);
  }

  isRotaVisualizarManifestacaoOuvidoria(path: string): boolean {
    return path.startsWith(ROTA_VISUALIZAR_MANIFESTACAO_OUVIDORIA);
  }

  mudouEntreContextosVisualizarManifestacao(
    newPath: string,
    oldPath: string
  ): boolean {
    return (
      (
        this.isRotaVisualizarManifestacaoMural(oldPath) &&
        this.isRotaVisualizarManifestacaoOuvidoria(newPath)
      ) ||
      (
        this.isRotaVisualizarManifestacaoOuvidoria(oldPath) &&
        this.isRotaVisualizarManifestacaoMural(newPath)
      )
    );
  }

  @Watch("$route.path")
  async onRoutePathChange(newPath: string, oldPath: string): Promise<void> {
    if (!this.mudouEntreContextosVisualizarManifestacao(newPath, oldPath)) return;

    await this.carregaManifestacao();
  }

  async mounted(): Promise<void> {
    await this.carregaManifestacao();
  }
}
</script>
